module.exports = __webpack_public_path__ + "img/software-development-process.55c9b683.jpg";